import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import _ from "lodash";

function headers(token) {
  if (token) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    };
  }

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}

export const getAllApplications = createAsyncThunk(
  "applications/get",
  async (data, { rejectWithValue, getState }) => {
    const token = localStorage.token;
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/application/all`,
        method: "POST",
        headers: headers(token),
        data,
      });
      if (response.status === "error") {
        return rejectWithValue(response);
      }
      return response;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const applicationsSlice = createSlice({
  name: "applications",
  initialState: {
    isLoading: false,
  },
  reducers: {
    saveValue: (state, action) => {
      return _.merge(state, action.payload);
    },
  },
  extraReducers: {
    [getAllApplications.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.applications = payload.data;
    },
    [getAllApplications.pending]: (state) => {
      state.isLoading = true;
      state.isFetching = true;
    },
    [getAllApplications.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.isFetching = false;
      state.isError = true;
    },
  },
});

export const { saveValue } = applicationsSlice.actions;

export const applicationsSelector = (state) => state.applications;
